import apiRequest from "../../helpers/apiRequest";

export default async (csrf) => {
    return await apiRequest({
        method: 'post',
        url: `accounts/dj-rest-auth/logout/`,
    })
}
